/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Source_Profile_LabelInputs */



/**
* | output |
* | --- |
* | "Source Profile" |
*
* @param {Subtitle_Import_Source_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_source_profile_label = /** @type {((inputs?: Subtitle_Import_Source_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Source_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellenprofil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Profilo sorgente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профиль источника")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perfil de la fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("来源概况")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースプロファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत प्रोफ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Perfil da fonte")
	return /** @type {LocalizedString} */ ("Source Profile")
});